// 채팅 별도 창의 **전달 수단**(설계서 §9.6.6) — 길(앱 Tauri 이벤트 · 브라우저 postMessage)은 파일 창과 함께 쓰는
// `popup/windowLink.ts` 에 있다. 여기는 채팅 규약(`popupProtocol.ts`)을 끼운 이름만 둔다.

import { connectPopup, openPopup, type WindowLink } from '../popup/windowLink';
import { CHAT_WINDOW_SPEC, isHostToWin, isWinToHost, type HostToWin, type WinToHost } from './popupProtocol';

/** 한쪽 끝. `In` = 받는 메시지, `Out` = 보내는 메시지. */
export type ChatLink<In, Out> = WindowLink<In, Out>;

export type HostLink = ChatLink<WinToHost, HostToWin>;
export type WinLink = ChatLink<HostToWin, WinToHost>;

/**
 * 채팅 창을 연다(이미 있으면 앞으로). 열지 못하면 null — 브라우저가 팝업을 막은 경우 등.
 * @param key   이 세션의 키(`newChatKey`)
 * @param title 창 제목
 * @param quiet 상대의 글이 와서 **저절로** 여는 경우 — 창을 활성화하지 않는다(앱만 가능, 2026-09-29).
 *              브라우저는 `window.open` 이 늘 포커스를 가져가므로 호출부(`useChat` autoOpen)가 애초에 부르지 않는다.
 */
export async function openChatWindow(key: string, title: string, quiet = false): Promise<HostLink | null> {
  return openPopup<WinToHost, HostToWin>(CHAT_WINDOW_SPEC, key, title, isWinToHost, quiet);
}

/** 채팅 창이 세션 창에 붙는다. 세션 창 없이 열렸으면(주소를 직접 연 경우) null. */
export async function connectToHost(): Promise<WinLink | null> {
  return connectPopup<HostToWin, WinToHost>(CHAT_WINDOW_SPEC, isHostToWin);
}
